import moment from "moment"
export const dateFormater = (value) => {
  if (!value) return "--";
  if (/^\d{2}-\d{2}-\d{4}$/.test(value)) {
    const [day, month, year] = value.split("-");
    return `${day}/${month}/${year}`;
  }
  const parsed = moment(value, [
    moment.ISO_8601,
    "YYYY-MM-DD HH:mm:ss",
    "YYYY-MM-DD",
    "DD-MM-YYYY",
    "DD/MM/YYYY",
    "YYYY/MM/DD",
    "MM/DD/YYYY"
  ]);
  if (parsed.isValid()) {
    return parsed.format("DD/MM/YYYY");
  }
  return value;
};

export const formatWhatsAppMessage = (template, variables = []) => {
  if (!template) return '';

  let msg = template;

  msg = msg.replace(/\\n/g, '\n');

  msg = msg.replace(/{{(\d+)}}/g, (_, num) => {
    return variables[num - 1] || `{{${num}}}`;
  });

  return msg
    .split('\n\n')
    .map(p => `<p>${p.trim()}</p>`)
    .join('');
};

export const filterConfig = {
  phase_type: {
    label: "Type",
    enum: {
      1: "Trial",
      2: "PMS",
      3: "Commercial",
    },
  },
  apheresis_date: {
    label: "Apheresis Date",
  },
};

export const labelTypeList = [
  { label: 'In-bound', value: '1' },
  { label: 'Product information sheet', value: '2' },
  { label: 'COA', value: '3' },
  { label: 'Out-bound', value: '4' },
  { label: 'LSM Label', value: '5' },
  // {label:'Finish Product Label',value:'6'},
  { label: 'Batch release certificate', value: '7' },
  { label: 'Cryopreserved LSM label', value: '8' }
]

export const filterConfigRecived = {
  phase_type: {
    label: "Type",
    enum: {
      1: "Trial",
      2: "PMS",
      3: "Commercial",
    },
  },
  cycle: {
    label: "Cycle",
  },
};
export const modalOption = ["change-patient-gender", "change-patient-name", "change-patient-date-of-birth", "change-financial-feasibility", "change-clinical-feasibility", "change-scheduled-aphresis-date-range", "change-dead-to-alive", "change-lost-to-follow-up-to-alive", "change-date-of-lost-to-follow-up", "change-date-of-death", "change-lost-to-follow-up-date", "change-dead-to-lost-to-follow-up", "change-lost-to-follow-up-to-dead"]
export const patientStatusModal = ["change-dead-to-alive", "change-lost-to-follow-up-to-alive", "change-date-of-lost-to-follow-up", "change-date-of-death", "change-lost-to-follow-up-date", "change-dead-to-lost-to-follow-up", "change-lost-to-follow-up-to-dead"]

export const CR_TEXT = 'CR raised';
export const slugMap = {
  delivery_partner_id: [
    "change-delivery-partner-id",
    "kit-change-delivery-partner-id",
    "final-change-delivery-partner-id"
  ],
  awb: [
    "change-awb-number",
    "kit-change-awb-number",
    "final-change-awb-number"
  ],
  tracking_link: [
    "change-tracking-link",
    "kit-change-tracking-link",
    "final-change-tracking-link"
  ]
};

export const filterConfigStatus = {
  status: {
    label: "status",
    enum: {
      0: "Pending",
      1: "Submitted",
      2: "Published",
      3: "Draft",
    },
  },
  versions: {
    label: "versions",

  },
};


export const extraFormOptions = [
  {
    name: "Hospital Id",
    id: "hospital_code",
    key: "Hospital Id PR"
  },
  {
    name: "Hospital Name",
    id: "hospital_name",
    key: "Hospital Name PR"
  },
  {
    name: "Treating Physician",
    id: "treating_physician",
    key: "Treating Physician PR"
  },
  {
    name: "Patient Full Name",
    id: "patient_name",
    key: "Patient Full Name PR"
  },
  {
    name: "Patient Initials",
    id: "patient_initials",
    key: "Patient Initials PR"
  },
  {
    name: "Date of Birth",
    id: "dob",
    key: "Date of Birth PR"
  },
  {
    name: "Age (Years)",
    id: "patient_age",
    key: "Age (Years) PR"
  },
  {
    name: "Patient Gender",
    id: "gender",
    key: "Patient Gender PR"
  },
  {
    name: "Hospital Given Patient ID",
    id: "hospital_patient_id",
    key: "Hospital Given Patient ID PR"
  },
  {
    name: "Patient Weight (kg)",
    id: "patient_body_weight",
    key: "Patient Weight (kg) PR"
  },
  {
    name: "Patients Nationality",
    id: "patients_nationality",
    key: "Patients Nationality PR"
  },
  {
    name: "State",
    id: "state_id",
    key: "State PR"
  },
  {
    name: "City",
    id: "city_id",
    key: "City PR"
  },
  {
    name: 'Nationality',
    id: "mention_nationality",
    key: "Nationality PR"
  },
  {
    name: "Primary Diagnosis",
    id: "primary_diagnosis_id",
    key: "Primary Diagnosis PR"
  },
  {
    name: "Subtype",
    id: "subtype",
    key: "Subtype PR"
  },
  {
    name: "Cytogenetic / Molecular Abnormalities",
    id: "cytogenetic_molecular_abnormalities",
    key: "Cytogenetic / Molecular Abnormalities PR"
  },
  {
    name: "Biopsy Confirmed",
    id: "biopsy_confirmed",
    key: "Biopsy Confirmed PR"
  },
  {
    name: "Bone marrow Biopsy/Flow-cytometry confirmed",
    id: "bone_marrow_biopsy",
    key: "Bone marrow Biopsy/Flow-cytometry confirmed PR"
  },
  {
    name: "Cytogenetic Report Available",
    id: "cytogenetic_report",
    key: "Cytogenetic Report Available PR"
  },
  {
    name: "Biopsy Report",
    id: "biopsy-confirmed-report",
    key: "Biopsy Report PR"
  },
  {
    name: "Cytogenetic/Karyotyping Report",
    id: "karyotyping-report",
    key: "Cytogenetic/Karyotyping Report PR"
  },
  {
    name: "Date of last Relapse/Refractoriness",
    id: "date_of_last_relapse_or_refractoriness",
    key: "Date of last Relapse/Refractoriness PR"
  },
  {
    name: "Number of PRior Lines of Therapy",
    id: "number_of_lines_of_therapies_prior_to_car_t",
    key: "Number of PRior Lines of Therapy PR"
  },
  {
    name: "Disease Status",
    id: "primary_refractory",
    key: "Disease Status PR"
  },
  {
    name: "Treatment History",
    id: "treatment_history",
    key: "Treatment History PR"
  },
  {
    name: "Last Treatment Regimen",
    id: "last_treatment_regimen",
    key: "Last Treatment Regimen PR"
  },
  {
    name: "Last Regimen Start/Stop Dates",
    id: "last_treatment_dates",
    key: "Last Regimen Start/Stop Dates PR"
  },
  {
    name: "Bulky Disease (Largest diameter of Tumor mass)",
    id: "bulky_disease_dlbcl",
    key: "Bulky Disease (Largest diameter of Tumor mass) PR"
  },
  {
    name: "Bulky disease - B-ALL (Blast %)",
    id: "b_all_blast_percentage",
    key: "Bulky disease - B-ALL (Blast %) PR"
  },
  {
    name: "ECOG Performance Score",
    id: "ecog_ps",
    key: "ECOG Performance Score PR"
  },
  {
    name: "LVEF %",
    id: "lvef_percentage",
    key: "LVEF % PR"
  },
  {
    name: "Baseline CRP",
    id: "baseline_crp_level",
    key: "Baseline CRP PR"
  },
  {
    name: "Baseline LDH",
    id: "baseline_ldh_level",
    key: "Baseline LDH PR"
  },
  {
    name: "HB",
    id: "hb",
    key: "HB PR"
  },
  {
    name: "ANC",
    id: "anc",
    key: "ANC PR"
  },
  {
    name: "ALC",
    id: "alc",
    key: "ALC PR"
  },
  {
    name: "Ferritin",
    id: "ferritin",
    key: "Ferritin PR"
  },
  {
    name: "Platelet count",
    id: "baseline_lymphocyte_to_monocyte_ratio",
    key: "Platelet count PR"
  },
  {
    name: "Patient's Occupation",
    id: "patient_occupation",
    key: "Patient's Occupation PR"
  },
  {
    name: "Family's Annual Income (INR)",
    id: "family_annual_income",
    key: "Family's Annual Income (INR) PR"
  },
  {
    name: "Latest Bone Marrow Aspiration & Biopsy Report",
    id: "biopsy-report",
    key: "Latest Bone Marrow Aspiration & Biopsy Report PR"
  },
  {
    name: "Latest MRD/Flow Cytometry Report",
    id: "flow-cytometry",
    key: "Latest MRD/Flow Cytometry Report PR"
  },
  {
    name: "Bone Marrow Aspiration & Biopsy Report at Diagnosis",
    id: "biopsy-diagnosis-report",
    key: "Bone Marrow Aspiration & Biopsy Report at Diagnosis PR"
  },
  {
    name: "Biopsy with IHC Report",
    id: "ihc-report",
    key: "Biopsy with IHC Report PR"
  },
  {
    name: "PET CT (if Extra-medullary disease)",
    id: "pet-scan",
    key: "PET CT (if Extra-medullary disease) PR"
  },
  {
    name: "Latest PET CT Report",
    id: "pet-ct-report",
    key: "Latest PET CT Report PR"
  },
  {
    name: "Treatment Summary till date on Hospital Letterhead",
    id: "discharge-summary",
    key: "Treatment Summary till date on Hospital Letterhead PR"
  },
  {
    name: "FISH / NGS / Cytogenetics",
    id: "cytogenetics-report",
    key: "FISH / NGS / Cytogenetics PR"
  },
  {
    name: "Latest Histopathology report with IHC report",
    id: "histopathology-report",
    key: "Latest Histopathology report with IHC report PR"
  },
  {
    name: "CSF / Neuro-imaging (if CNS disease)",
    id: "csf-report",
    key: "CSF / Neuro-imaging (if CNS disease) PR"
  },
  {
    name: "Ph+ve ALL",
    id: "bcrabl-report",
    key: "Ph+ve ALL PR"
  },
  {
    name: "Bone marrow aspiration and biopsy (if marrow involvement)",
    id: "bone-marrow-involvement",
    key: "Bone marrow aspiration and biopsy (if marrow involvement) PR"
  },
  {
    name: "Chimerism Report (if PRst transplant)",
    id: "chimerism-report",
    key: "Chimerism Report (if PRst transplant) PR"
  },
  {
    name: "Serum Immunoglobulin Levels",
    id: "serum-immunoglobulin",
    key: "Serum Immunoglobulin Levels PR"
  },
  {
    name: "Histopathology report with IHC report at diagnosis",
    id: "histopathology-diagnosis-report",
    key: "Histopathology report with IHC report at diagnosis PR"
  },
  {
    name: "Latest CBC Report",
    id: "cbc-report",
    key: "Latest CBC Report PR"
  },
  {
    name: "Latest Biochemistry Reports (LFT/RFT)",
    id: "biochemistry-report",
    key: "Latest Biochemistry Reports (LFT/RFT) PR"
  },
  {
    name: "Serology Reports(HIV/ HCV/HBV/CMV)",
    id: "serology",
    key: "Serology Reports(HIV/ HCV/HBV/CMV) PR"
  },
  {
    name: "Any Additional reports",
    id: "additional-report",
    key: "Any Additional reports PR"
  },
  {
    id: "apheresisDateRange",
    name: "Scheduled Apheresis Date Range",
    key: "Scheduled Apheresis Date Range PR"
  },
  {
    id: "preferred_date",
    name: "Preferred Date",
    key: "Preferred Date PR"
  }
];

export const roleBasedExclusions = {
  1: [
    "Kit Dispatched Detail Update",
    "Final Product Dispatched Update",
    "Infusion Date",
    "LSM Detail Update",
    "Publish Product",
    "Batch Details Update",
    "Publish Product",
    "Batch Details Update",
  ]
};

export const cardRouteMap = {
  "patient_feasibility": {
    route: "/bmr/feasibility-assessment/subjects",
    permissionType: "bmr_permission",
    permissions: ["marked-financial-feasible", "marked-clinical-feasible"],
  },
  "onboarding_pre_screening": {
    route: "/bmr/feasibility-assessment/subjects",
    permissionType: "bmr_permission",
    permissions: ["subjects-listing", "subjects-view-details"],
  },
  "slot_scheduling": {
    route: "/bmr/feasibility-assessment/bmr-slots",
    permissionType: "bmr_permission",
    permissions: ["bmr-slots-view"],
  },
  "product_manufacturing": {
    route: "/bmr/manufacturer",
    permissionType: "bmr_permission",
    permissions: ["product-manufacturing-process-listing", "start-manufacturing"],
  },
  "infusion": {
    route: "/bmr/logistics-management/out-bound",
    permissionType: "bmr_permission",
    permissions: ["outbound-patient-list", "outbound-patient-view"],
  },
  "finished_product_dispatch": {
    route: "/bmr/logistics-management/out-bound",
    permissionType: "bmr_permission",
    permissions: ["quality-approval-listing", "outbound-patient-list"],
  },
  "lsm_dispatched": {
    route: "/bmr/logistics-management/in-bound",
    permissionType: "bmr_permission",
    permissions: ["in-bound-listing"],
  },
  "lsm_accepted": {
    route: "/bmr/manufacturer",
    permissionType: "bmr_permission",
    permissions: ["product-manufacturing-process-listing", "start-manufacturing"],
  },
};